import { clsx } from 'clsx';
import { RefreshCw } from 'lucide-react';
// GradeBadge used below
import type { Grade } from '@/types';

interface GradeButtonProps {
  grade: Grade | string | null;
  onGrade: () => void;
  onRegrade: () => void;
  onViewGrade: () => void;
  hasRequiredData: boolean;
  requiredDataMessage?: string;
  isLoading?: boolean;
  colorScheme?: 'emerald' | 'cyan' | 'amber' | 'rose' | 'teal';
  label?: string;
}

const colorSchemes = {
  emerald: 'from-emerald-500 to-emerald-700 hover:from-emerald-400 hover:to-emerald-600',
  cyan: 'from-cyan-500 to-cyan-700 hover:from-cyan-400 hover:to-cyan-600',
  amber: 'from-amber-500 to-amber-700 hover:from-amber-400 hover:to-amber-600',
  rose: 'from-rose-500 to-rose-700 hover:from-rose-400 hover:to-rose-600',
  teal: 'from-teal-500 to-teal-700 hover:from-teal-400 hover:to-teal-600',
};

export function GradeButton({
  grade,
  onGrade,
  onRegrade,
  onViewGrade,
  hasRequiredData,
  requiredDataMessage = 'Scrape data first',
  isLoading,
  colorScheme = 'emerald',
  label = 'Grade',
}: GradeButtonProps) {
  if (!hasRequiredData) {
    return (
      <span
        className="text-xs text-gray-500 cursor-help"
        title={requiredDataMessage}
      >
        -
      </span>
    );
  }

  if (grade) {
    return (
      <div className="flex items-center gap-1">
        <button
          onClick={onViewGrade}
          className="px-2 py-0.5 rounded font-bold text-xs bg-green-500 text-white hover:bg-green-400"
        >
          {grade}
        </button>
        <button
          onClick={onRegrade}
          className="text-gray-500 hover:text-blue-400 text-xs p-1"
          title="Re-grade (free)"
        >
          <RefreshCw className="w-3 h-3" />
        </button>
      </div>
    );
  }

  if (isLoading) {
    return (
      <span className="text-xs text-gray-400 animate-pulse">...</span>
    );
  }

  return (
    <button
      onClick={onGrade}
      className={clsx(
        'px-2 py-1 rounded text-xs font-medium transition-all text-white',
        'bg-gradient-to-br',
        colorSchemes[colorScheme]
      )}
    >
      {label}
    </button>
  );
}
